
import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box, IconButton } from "@material-ui/core";

import ButtonAtom from '../../component/ButtonAtom/index.jsx'
import { makeStyles } from '@material-ui/styles';
import PersonIcon from '@mui/icons-material/Person';
import FooterBar from './../../component/FooterAtom/index'
import VisibilityIcon from '@mui/icons-material/Visibility';
import Drawer from '@material-ui/core/Drawer';
import Folder1 from './../../pages/Folder/Folder'
import ReplyIcon from '@mui/icons-material/Reply';

import { useHistory } from 'react-router-dom';


import firebase from "../../config/firebase/index";
import editProfileScreen from './../../pages/Editpost/EditPost';
import Folder from './../../pages/Folder/Folder';
import MyDeals_AllBids from '../MyDeals_AllBids/MyDeals_AllBids.js';
import EditPost from './../../pages/Editpost/EditPost';

import ReactGA from 'react-ga';
import encSecret from '../../config/encryption/index.js';
import NoFollowMeta from '../../component/NofollowMeta/index.jsx';
var CryptoJS = require("crypto-js");


const My_Deals = () => {

    const history = useHistory();
    const classes = useStyles();
    const [deals, setDeals] = useState([]);
    const [selectedDeal, setSelectedDeal] = useState("");
    const [open, setOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const user = JSON.parse(localStorage.getItem("user"));
    const [oldDeals, setOldDeals] = useState([]);
    const [date, setDate] = useState(new Date());
    const [index, setIndex] = useState(0);


    const isDealer = user[0].dealerFlag;

    const phoneCallsInMyDeals = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }


    const bidsInMyDeals = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }

    const viewsInMyDeals = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }


    const whatsAppMsgInMyDeals = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }

    const shareDeal = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }



    const toggleDrawer = (dealid, date, index) => {
        // console.log(dealid)
        if (dealid) {
            setSelectedDeal(dealid)
            setIndex(index);
        }

        setOpen(true);
    };

    const editToggleDrawer = (dealid, date) => {
        // console.log(dealid)
        if (dealid) {
            setSelectedDeal(dealid);
            setDate(date);
        }
        setEditOpen(true);
    };

    const formatMonthDate = (num) => {
        return parseInt(num) > 9 ? num : "0" + num;
    }

    const AllDeals = () => {
        // const phnNumber = CryptoJS.HmacSHA1(localStorage.getItem("Phone Number"), encSecret.key).toString();
        firebase.database().ref("Product").orderByChild("DealerNumber")
            .equalTo(localStorage.getItem("Phone Number")).on("value", snapshot => {

                const dealData = snapshot.val();
                console.log(dealData)
                const tempDeals = [];
                const tempOldDeals = [];
                const today = new Date();
                const currentDate = today.getFullYear() + '-' + formatMonthDate(today.getMonth() + 1) + '-' + formatMonthDate(today.getDate());
                let dealDate = new Date();
                let count = 0;
                // console.log(currentDate);
                for (const key in dealData) {
                    count++;
                    const dealObj = {
                        id: key,
                        ...dealData[key],
                    };
                    dealDate = dealObj.createdAt.split(" ")[0];
                    if (dealDate === currentDate) {
                        tempDeals.push(dealObj);
                    } else {
                        tempOldDeals.push(dealObj);
                    }
                }
                console.log(count);
                setDeals(tempDeals);
                setOldDeals(tempOldDeals);
            })
    }

    useEffect(() => {
        AllDeals();

        // let str = "U2FsdGVkX19ZKEL8WnlSr+sFHpXe26nFfYVPpBLT5YY=";
        // let dstr = CryptoJS.AES.decrypt(str, encSecret.key).toString(CryptoJS.enc.Utf8);
        // console.log("DEcrypted ::: ", dstr);

    }, []);


    return (
        <Grid p={2} className={classes.commonSectionBuild} style={{ paddingBottom: '30px' }}>
            <NoFollowMeta />
            <Box className={classes.headerBrowser1}>
                <Typography variant="h6" style={{ fontWeight: 600 }} className={classes.commonNameCenter}>
                    मेरे सौदे
                </Typography>
                <IconButton onClick={() => history.push('/profile')}>

                    <PersonIcon fontSize="large" />
                </IconButton>
            </Box>
            <Typography className={classes.border}></Typography>

            <Box className={classes.headerBrowser1}>
                <Typography variant="h6" style={{ fontWeight: 600 }} >
                    आज के सौदे
                </Typography>

            </Box>

            {deals && deals.map((deal, index) => (
                <Box className={classes.midScroll} key={index} style={{ border: (deal && deal.isPublic) ? "1px solid black" : "none" }}>
                    <Box className={classes.contentBox}>
                        <Box className={`${classes.contetnArrange} ${classes.oneByOne}`}>
                            <Box>
                                <img width="80px" height="80px" src={deal.image} alt="" />
                            </Box>
                            <Box>
                                <Typography variant="body1" style={{ fontWeight: 600 }}>{deal.productName}</Typography>
                                <Box className={classes.loatBorderRight}>
                                    <Typography variant="caption">{deal.Quantity}</Typography><br />
                                    <Typography variant="OVERLINE">{deal.QuantityUnit}</Typography>
                                </Box>
                            </Box>
                            <Box>
                                <Typography variant="caption" style={{ fontWeight: 700 }} >Rs. {CryptoJS.AES.decrypt(deal.Min, encSecret.key).toString(CryptoJS.enc.Utf8)}-{CryptoJS.AES.decrypt(deal.Max, encSecret.key).toString(CryptoJS.enc.Utf8)}</Typography>
                                <Box>
                                    <Typography variant="caption">स्थान</Typography><br />
                                    <Typography variant="OVERLINE">{deal.Place}</Typography>
                                </Box>
                            </Box>
                        </Box>

                    </Box>
                    <Box className={classes.keematBox}>
                        <Typography variant="body1" className={classes.keemat} >इच्छुक पार्टिया </Typography>
                        <Box className={classes.contetnArrange} style={{ display: "grid", gridTemplateColumns: "30% 30% 30%" }}>
                            <Box mr={2}>
                                <Typography variant="caption" style={{ color: "#532550", fontWeight: 600 }}>देखा गया </Typography>
                                <Box mr={3} className={`${classes.keematBox} ${classes.keematBox1}`}>
                                    <ButtonAtom
                                        name={deal.analytics.views}
                                        cclass="icchukParties"

                                        onClick={() => { viewsInMyDeals('My Deals', 'Click', 'View Deal'); toggleDrawer(deal.DealId, '', 0) }}
                                    />
                                </Box>

                            </Box>
                            {/* <Box mr={2}>
                                <Typography variant="caption" style={{ color: "#532550", fontWeight: 600 }}>फ़ोन कॉल </Typography>
                                <Box mr={3} className={`${classes.keematBox} ${classes.keematBox1}`}>
                                    <ButtonAtom
                                        name={deal.analytics.phone}
                                        cclass="icchukParties"

                                        onClick={() => { phoneCallsInMyDeals('My Deals', 'Click', 'Phone Call'); toggleDrawer(deal.DealId, '', 1)}}
                                    />
                                </Box>

                            </Box> */}
                            <Box mr={2}>
                                <Typography variant="caption" style={{ color: "#532550", fontWeight: 600 }}>बोलियां </Typography>
                                <Box mr={3} className={`${classes.keematBox} ${classes.keematBox1}`}>
                                    <ButtonAtom
                                        name={deal.analytics.suggest ? deal.analytics.suggest : 0}
                                        cclass="icchukParties"

                                        onClick={() => { bidsInMyDeals('My Deals', 'Click', 'Bid'); toggleDrawer(deal.DealId, '', 1) }}
                                    />
                                </Box>

                            </Box>
                            <Box mr={2}>
                                <Typography variant="caption" style={{ color: "#532550", fontWeight: 600 }}>व्हाट्सप्प सन्देश </Typography>
                                <Box mr={3} className={`${classes.keematBox} ${classes.keematBox1}`}>
                                    <ButtonAtom
                                        name={deal.analytics.whatsapp}
                                        cclass="icchukParties"

                                        onClick={() => { whatsAppMsgInMyDeals('My Deals', 'Click', 'WhatsApp message'); toggleDrawer(deal.DealId, '', 2) }}
                                    />
                                </Box>

                            </Box>




                        </Box>

                        {/* <Box>
                            <Typography >बोलियां : {deal.analytics.suggest ? deal.analytics.suggest : 0}</Typography>
                        </Box> */}

                        <Box>

                            <ButtonAtom mb={3}
                                name=" Share deal "
                                cclass="shareDealButton"
                                startIcon={<ReplyIcon className={`${classes.rotateSHareIcon} ${classes.iconInFront}`} />}
                                onClick={() => { shareDeal('My Deals', 'Click', 'Share'); editToggleDrawer(deal.DealId, deal.createdAt.split(" ")[0]) }}
                            />

                        </Box>
                        {(deal && deal.isPublic) ?
                            <Box>
                                <Typography variant="caption" style={{ color: "#532550", fontWeight: 600, float: "right", padding: 3 }}>यह सौदा सार्वजनिक है</Typography>
                            </Box>
                            : <></>}
                    </Box>
                </Box>
            )).reverse()
            }

            <Box className={classes.headerBrowser1}>
                <Typography variant="h6" style={{ fontWeight: 600 }} >
                    पुराने सौदे
                </Typography>

            </Box>
            {oldDeals && oldDeals.map((deal, index) => (
                <Box className={classes.midScroll} key={index} style={{ border: (deal && deal.isPublic) ? "1px solid black" : "none" }}>
                    <Box className={classes.contentBox}>
                        <Box className={`${classes.contetnArrange} ${classes.oneByOne}`}>
                            <Box>
                                <img width="80px" height="80px" src={deal.image} alt="" />
                            </Box>
                            <Box>
                                <Typography variant="body1" style={{ fontWeight: 600 }}>{deal.productName}</Typography>
                                <Box className={classes.loatBorderRight}>
                                    <Typography variant="caption">{deal.Quantity}</Typography><br />
                                    <Typography variant="OVERLINE">{deal.QuantityUnit}</Typography>
                                </Box>
                            </Box>
                            <Box>
                                <Typography variant="caption" style={{ fontWeight: 700 }} >Rs. {CryptoJS.AES.decrypt(deal.Min, encSecret.key).toString(CryptoJS.enc.Utf8)}-{CryptoJS.AES.decrypt(deal.Max, encSecret.key).toString(CryptoJS.enc.Utf8)}</Typography>
                                <Box>
                                    <Typography variant="caption">स्थान</Typography><br />
                                    <Typography variant="OVERLINE">{deal.Place}</Typography>
                                </Box>
                            </Box>
                        </Box>

                    </Box>
                    <Box className={classes.keematBox}>
                        <Typography variant="body1" className={classes.keemat} >इच्छुक पार्टिया </Typography>
                        <Box className={classes.contetnArrange} style={{ display: "grid", gridTemplateColumns: "30% 30% 30%" }}>
                            <Box mr={2}>
                                <Typography variant="caption" style={{ color: "#532550", fontWeight: 600 }}>देखा गया </Typography>
                                <Box mr={3} className={`${classes.keematBox} ${classes.keematBox1}`}>
                                    <ButtonAtom
                                        name={deal.analytics.views}
                                        cclass="icchukParties"

                                        onClick={() => { viewsInMyDeals('My Deals', 'Click', 'View Deal'); toggleDrawer(deal.DealId, '', 0) }}
                                    />
                                </Box>

                            </Box>
                            {/* <Box mr={2}>
                                <Typography variant="caption" style={{ color: "#532550", fontWeight: 600 }}>फ़ोन कॉल </Typography>
                                <Box mr={3} className={`${classes.keematBox} ${classes.keematBox1}`}>
                                    <ButtonAtom
                                        name={deal.analytics.phone}
                                        cclass="icchukParties"

                                        onClick={() => { phoneCallsInMyDeals('My Deals', 'Click', 'Phone Call'); toggleDrawer(deal.DealId, '', 1) }}
                                    />
                                </Box>

                            </Box> */}
                            <Box mr={2}>
                                <Typography variant="caption" style={{ color: "#532550", fontWeight: 600 }}>बोलियां</Typography>
                                <Box mr={3} className={`${classes.keematBox} ${classes.keematBox1}`}>
                                    <ButtonAtom
                                        name={deal.analytics.suggest ? deal.analytics.suggest : 0}
                                        cclass="icchukParties"

                                        onClick={() => { bidsInMyDeals('My Deals', 'Click', 'Bid'); toggleDrawer(deal.DealId, '', 1) }}
                                    />
                                </Box>

                            </Box>
                            <Box mr={2}>
                                <Typography variant="caption" style={{ color: "#532550", fontWeight: 600 }}>व्हाट्सप्प सन्देश </Typography>
                                <Box mr={3} className={`${classes.keematBox} ${classes.keematBox1}`}>
                                    <ButtonAtom
                                        name={deal.analytics.whatsapp}
                                        cclass="icchukParties"

                                        onClick={() => { whatsAppMsgInMyDeals('My Deals', 'Click', 'WhatsApp message'); toggleDrawer(deal.DealId, '', 2) }}
                                    />
                                </Box>

                            </Box>


                        </Box>

                        {/* <Box>
                            <Typography >बोलियां : {deal.analytics.suggest ? deal.analytics.suggest : 0}</Typography>
                        </Box> */}

                        <Box>

                            <ButtonAtom mb={3}
                                name=" Share deal"
                                cclass="shareDealButton"
                                startIcon={<ReplyIcon className={`${classes.rotateSHareIcon} ${classes.iconInFront}`} />}
                                onClick={() => { shareDeal('My Deals', 'Click', 'Share'); editToggleDrawer(deal.DealId, deal.createdAt.split(" ")[0]) }}
                            />

                        </Box>
                        {(deal && deal.isPublic) ?
                            <Box>
                                <Typography variant="caption" style={{ color: "#532550", fontWeight: 600, float: "right", padding: 3 }}>यह सौदा सार्वजनिक है</Typography>
                            </Box>
                            : <></>}
                    </Box>
                </Box>
            )).reverse()
            }



            <Box mt={5}>
                <FooterBar isDealer={isDealer} active={[0, 0, 1, 0]} />
            </Box>

            <div>
                <React.Fragment>
                    <Drawer className={classes.drawerDesign} anchor={'bottom'} open={open}>
                        <MyDeals_AllBids closePopUp={setOpen} dealId={selectedDeal} sindex={index} />
                    </Drawer>
                </React.Fragment>
            </div>
            <div>
                <React.Fragment>
                    <Drawer className={classes.drawerDesign} anchor={'bottom'} open={editOpen}>
                        <EditPost closePopUp={setEditOpen} dealId={selectedDeal} date={date} />
                    </Drawer>
                </React.Fragment>
            </div>

        </Grid>

    )
};

const useStyles = makeStyles(() => ({
    keematBox2: {
        background: '#eee',
        padding: 20,
        textAlign: 'center',
        boxSizing: 'border-box',
        background: '#ddd',
        width: '50%',
    },
    drawerDesign: {
        '& .MuiDrawer-paper': {
            paddingTop: 30,
            borderRadius: '20px 20px 0 0',
            height: '700px',
        }
    },
    midScroll: {
        maxHeight: 'calc(100vh - 120px)',
        marginBottom: "20px",
        borderRadius: '6px',
        boxShadow: '0 10px 10px 0 #ddd',
        borderRadius: '6px',
        padding: 1,
    },
    oneByOne: {

        boxShadow: '0 0 10px #ddd',
        borderRadius: '6px',
    },
    headerBrowser: {
        background: '#fff',
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 0',
        boxSizing: 'border-box',
        alignItems: 'center',
        overflowX: 'auto',
        '& > .MuiBox-root': {
            minWidth: '40%',
        }
    },
    commonSectionBuild: {
        maxWidth: 540,
        width: '93%',
        float: 'none',
        margin: 'auto',
        // padding: '0 15px',
        boxSizing: 'border-box',

    },
    text: {
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',

    },
    headerBrowser1: {
        background: '#fff',
        color: 'black',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        alignItems: 'center',
        boxSizing: 'border-box',
    },
    headerBrowser2: {
        background: '#fff',
        color: 'black',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
        position: 'relative',
        borderColor: '#53252f',
        '& input': {
            paddingLeft: 50,
        }

    },
    commonNameCenter: {
        alignItems: 'center',
        marginLeft: '100px',
        marginRight: '60px',
        size: '20px',
    },
    headerBrowser3: {
        position: 'absolute',
        top: 25,
        left: 30,
        color: '#53252f'

    },
    keematBox: {
        background: '#eee',
        padding: 20,
        textAlign: 'center',
        boxSizing: 'border-box',

    },
    contetnArrange: {
        width: '100%',
        padding: '10px 10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        '& div': {
            width: '100%'
        }

    },
    saudaDekhna: {
        // marginLeft: '-30px',
    },
    contentBox: {
        background: '#fff',
        padding: 0,
        boxSizing: 'border-box',
        marginBottom: "0px",
        width: "100%",
        marginLeft: "0px",
    },

    keemat: {
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
    },
    keematBox1: {
        background: '#ddd',
    },
    loatBorderRight: {
        borderRight: 'solid 1px #ddd',
        width: '70% !important',

    },
    border: {
        borderBottom: 'solid 1px #ddd',

    },
    iconInFront: {
        position: 'absolute',
        right: 80,
        bottom: '13px'
    },
    rotateSHareIcon: {
        transform: 'rotateY(180deg)',
    },

}));

export default My_Deals;